export default __webpack_public_path__ + "static/media/sf.a54be76c.jpeg";